<template>
    <el-drawer
        title=""
        class="permis-edit"
        :size="['jp', 'tw', 'cn'].includes(lang) ? '650px' : '750px'"
        :visible.sync="visible"
        direction="rtl"
        :before-close="handleClose"
    >
        <i18n style="margin: 10px 0 30px" tag="h3" path="role18" class="tt">
            <strong style="color: #ccc" slot="name">
                {{ permissions.name }}
            </strong>
        </i18n>
        <template>
            <el-form ref="form" label-width="80px" label-position="top">
                <el-form-item :label="$t('role6')" style="margin-right: 40px">
                    <el-radio-group
                        v-model="user"
                        :disabled="permissions.type === 1"
                    >
                        <el-radio :label="0">
                            {{ $t("role9") }}
                            <div class="tips-x">
                                <i class="av-icon-sm icon-tips"></i>
                                <div class="tips-cnt top">
                                    <div class="tips-cnt-txt">
                                        {{ $t("role23") }}
                                    </div>
                                </div>
                            </div>
                        </el-radio>
                        <el-radio :label="2">
                            {{ $t("role8") }}
                            <div class="tips-x">
                                <i class="av-icon-sm icon-tips"></i>
                                <div class="tips-cnt top cet">
                                    <div class="tips-cnt-txt">
                                        {{ $t("role24") }}
                                    </div>
                                </div>
                            </div>
                        </el-radio>
                        <el-radio :label="1">
                            {{ $t("role7") }}
                            <div class="tips-x">
                                <i class="av-icon-sm icon-tips"></i>
                                <div class="tips-cnt top lf">
                                    <div class="tips-cnt-txt">
                                        {{ $t("role22") }}
                                    </div>
                                </div>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    :label="$t('menu.deviceManagement')"
                    style="margin-right: 40px"
                >
                    <el-radio-group
                        v-model="device"
                        :disabled="permissions.type === 1"
                    >
                        <el-radio :label="0">
                            {{ $t("role9") }}
                            <div class="tips-x">
                                <i class="av-icon-sm icon-tips"></i>
                                <div class="tips-cnt top">
                                    <div class="tips-cnt-txt">
                                        {{ $t("role21") }}
                                    </div>
                                </div>
                            </div>
                        </el-radio>
                        <el-radio :label="2">
                            {{ $t("role8") }}
                            <div class="tips-x">
                                <i class="av-icon-sm icon-tips"></i>
                                <div class="tips-cnt top cet">
                                    <div class="tips-cnt-txt">
                                        {{ $t("role20") }}
                                    </div>
                                </div>
                            </div>
                        </el-radio>
                        <el-radio :label="1">
                            {{ $t("role7") }}
                            <div class="tips-x">
                                <i class="av-icon-sm icon-tips"></i>
                                <div class="tips-cnt top lf">
                                    <div class="tips-cnt-txt">
                                        {{ $t("role19") }}
                                    </div>
                                </div>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('role10')">
                    <!-- <el-tag v-for="it in ctrl" :key="it.name" style="margin-right: 10px">
                        {{
                            it.name === "Ungrouped"
                                ? $t("deploy.unGrp")
                                : it.name
                        }}
                        <span v-if="it.devChecked !== it.devTotal" style="margin-left: 5px">
                            {{ `${it.devChecked}/${it.devTotal}` }}
                        </span>
                    </el-tag> -->
                    <span v-for="it in ctrl" :key="it.name">
                        <el-tag
                            v-if="!(it.devChecked === 0 && it.devTotal !== 0)"
                            style="margin-right: 10px"
                        >
                            {{
                                it.name === "Ungrouped"
                                    ? $t("deploy.unGrp")
                                    : it.name
                            }}
                            <span
                                v-if="it.devChecked !== it.devTotal"
                                style="margin-left: 5px"
                            >
                                {{ `${it.devChecked}/${it.devTotal}` }}
                            </span>
                        </el-tag>
                    </span>
                </el-form-item>
                <el-form-item>
                    <el-input
                        :placeholder="$t('role25')"
                        prefix-icon="el-icon-search"
                        v-model="search"
                        @input="debouncedsearchChange"
                        :disabled="permissions.type === 1"
                    >
                    </el-input>
                    <div class="group-tree">
                        <!-- 分组列表 -->
                        <vxe-table
                            v-if="!this.search"
                            border="none"
                            ref="xTree"
                            row-id="idx"
                            min-height="300"
                            :loading="loading"
                            :row-config="{ isCurrent: true, isHover: true }"
                            :tree-config="{
                                lazy: true,
                                transform: true,
                                rowField: 'idx',
                                parentField: 'parentID',
                                iconLoaded: 'am-icon-treeload',
                                expandRowKeys: [],
                                // expandAll: true,
                                loadMethod: loadChildrenMethod,
                                toggleMethod: toggleMethod,
                            }"
                            :checkbox-config="{
                                checkField: 'isChecked',
                                indeterminateField: 'indeterminate',
                                showHeader: false,
                                checkMethod: checkboxsMethod,
                            }"
                            :data="treeData"
                            @checkbox-change="selectChange"
                        >
                            <vxe-column type="checkbox" width="50" tree-node>
                                <template #default="{ row }">
                                    <!-- <span class="f-mid">
                                        {{ row.showName }}
                                    </span> -->
                                    <div
                                        v-if="
                                            row.idx.match(/^root/) &&
                                            row.checked !== 2
                                        "
                                        class="other-tips-cnt btm rt"
                                    >
                                        <div class="tips-cnt-txt">
                                            <!-- {{
                                                row.devTotal === 0
                                                    ? $t("role30")
                                                    : $t("role26")
                                            }} -->
                                            {{ $t("role26") }}
                                        </div>
                                    </div>
                                </template>
                            </vxe-column>

                            <vxe-column field="showName">
                                <template #default="{ row }">
                                    <i class="icon-dev" v-if="row.icon"> </i>
                                    <span class="f-mid">
                                        {{ row.showName }}
                                    </span>
                                    <div
                                        class="tips-x"
                                        v-if="row.quickConnect === 0"
                                    >
                                        <i class="av-icon-sm icon-tips"></i>
                                        <div class="tips-cnt btm rt">
                                            <div class="tips-cnt-txt">
                                                {{ $t("role27") }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </vxe-column>
                            <vxe-column class="td-id" field="deviceID">
                            </vxe-column>
                            <!-- 空状态 -->
                            <template v-slot:empty>
                                <div class="table-empty">
                                    <i
                                        class="empty-device"
                                        style="margin-top: 40px"
                                    ></i>
                                    <i18n tag="p" path="role28">
                                        <el-button
                                            slot="deploy"
                                            type="text"
                                            style="padding: 0 0"
                                            @click="goDeploy"
                                        >
                                            {{ $t("perDev.deploy") }}
                                        </el-button>
                                    </i18n>
                                </div>
                            </template>
                            <!-- 空状态 -->
                            <!-- 加载状态 -->
                            <template v-slot:loading>
                                <div class="table-loading">
                                    <div class="el-loading-spinner">
                                        <svg
                                            width="200px"
                                            class="circular"
                                            viewBox="25 25 50 50"
                                        >
                                            <circle
                                                class="path"
                                                cx="50"
                                                cy="50"
                                                r="20"
                                                fill="none"
                                            />
                                        </svg>
                                        <p class="el-loading-text">
                                            {{ $t("loading") }}
                                        </p>
                                    </div>
                                </div>
                            </template>
                            <!-- 加载状态 -->
                        </vxe-table>

                        <!-- 搜索的分组列表 -->
                        <vxe-table
                            v-else
                            border="none"
                            ref="sTree"
                            row-id="idx"
                            min-height="300"
                            :loading="loading"
                            :row-config="{ isCurrent: true, isHover: true }"
                            :tree-config="{
                                transform: true,
                                rowField: 'idx',
                                parentField: 'parentID',
                                iconLoaded: 'am-icon-',
                                expandAll: true,
                            }"
                            :checkbox-config="{
                                checkField: 'isChecked',
                                indeterminateField: 'indeterminate',
                                showHeader: false,
                                checkMethod: checkboxsMethod,
                            }"
                            :data="searchTree"
                            @checkbox-change="selectChange"
                        >
                            <vxe-column type="checkbox" width="50" tree-node>
                                <template #default="{ row }">
                                    <i class="mr6" v-if="row.icon">
                                        <!-- 空白占位间距，不要删除 -->
                                    </i>
                                    <div
                                        v-if="
                                            row.idx.match(/^root/) &&
                                            row.checked !== 2
                                        "
                                        class="other-tips-cnt btm rt"
                                    >
                                        <div class="tips-cnt-txt">
                                            {{
                                                row.devTotal === 0
                                                    ? $t("role30")
                                                    : $t("role26")
                                            }}
                                        </div>
                                    </div>
                                </template>
                            </vxe-column>

                            <vxe-column field="showName">
                                <template #default="{ row }">
                                    <span class="f-mid">
                                        {{ row.showName }}
                                    </span>
                                    <div
                                        class="tips-x"
                                        v-if="row.quickConnect === 0"
                                    >
                                        <i class="av-icon-sm icon-tips"></i>
                                        <div class="tips-cnt btm rt">
                                            <div class="tips-cnt-txt">
                                                {{ $t("role27") }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </vxe-column>
                            <vxe-column class="td-id" field="deviceID">
                            </vxe-column>
                            <!-- 空状态 -->
                            <template v-slot:empty>
                                <div class="table-empty">
                                    {{ $t("role29", { search: search }) }}
                                </div>
                            </template>
                            <!-- 空状态 -->
                            <!-- 加载状态 -->
                            <template v-slot:loading>
                                <div class="table-loading">
                                    <div class="el-loading-spinner">
                                        <svg
                                            width="200px"
                                            class="circular"
                                            viewBox="25 25 50 50"
                                        >
                                            <circle
                                                class="path"
                                                cx="50"
                                                cy="50"
                                                r="20"
                                                fill="none"
                                            />
                                        </svg>
                                        <p class="el-loading-text">
                                            {{ $t("loading") }}
                                        </p>
                                    </div>
                                </div>
                            </template>
                            <!-- 加载状态 -->
                        </vxe-table>
                    </div>
                </el-form-item>
            </el-form>
        </template>
        <div class="drawer-bottom">
            <el-button @click="handleClose">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="save" :loading="saveBtnLoading">{{
                $t("save")
            }}</el-button>
        </div>
    </el-drawer>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { debounce } from "@/utils/util";
import i18n from "@/lang/index";
import {
    getRoleGroupList,
    getRoleGoupDevList,
    saveRoleSettings,
    queryTeamEquipment,
} from "@/api/index";
// 格式化分组结构
const formatparentData = function (data) {
    const rooTree = data.map((r, i) => {
        return Object.assign(r, {
            idx: "root_" + r.id, // 为了方便自动展开
            hasChild: r.devTotal !== 0,
            showName: r.id === 0 ? i18n.t("deploy.unGrp") : r.name,
            parentID: null,
            isChecked: r.checked === 2, // 用于展示选中状态
            indeterminate: r.checked === 1,
        });
    });
    console.log("[ data formatparentHisDeviceData ] >", rooTree);
    return rooTree;
};

// 格式化分组设备结构
const formatChildrenData = function (data, row) {
    // checked [0:否|1:部分设备可控|2:所有设备可控]
    console.log(row.indeterminate, row, "是否indeterminate");
    const tree = data.map((r, i) => {
        return Object.assign(r, {
            idx: `rroot_${r.deviceID}`,
            showName: r.memo || r.nickName,
            hasChild: false,
            parentID: row.idx,
            isChecked: row.indeterminate ? r.checked : row.isChecked, // 用于展示选中状态
            parentName: row.showName,
            parentDevTotal: row.devTotal,
            icon: "dev",
        });
    });
    return tree;
};

// 格式化搜索分组树形结构
const formatSearchTree = function (data) {
    const tree = [];
    data.forEach((item, index) => {
        item.idx = "root_" + index;
        item.showName = item.ID === 0 ? i18n.t("deploy.unGrp") : item.name;
        item.parentID = null;
        item.isChecked = item.checked === 2;
        item.indeterminate = item.checked === 1;
        item.hasChild = true;
        tree.push(item);
        if (item.devices) {
            item.devices.forEach((it, i) => {
                it.idx = `rroot_${it.deviceID}`;
                it.showName = it.memo || it.nickName;
                it.parentID = item.idx;
                it.isChecked = it.checked !== 0;
                it.hasChild = false;
                it.parentName = item.name;
                it.parentDevTotal = item.devTotal;
                it.icon = "dev";
                tree.push(it);
            });
        }
    });
    return tree;
};

const dealChange = function (originData, currtentData) {
    return originData.filter((item) => {
        // 使用 some 方法检查是否在 selected 中存在相同的 deviceID
        const existsInSelected = currtentData.some(
            (it) => it.deviceID === item.deviceID
        );

        // 如果在 selected 中存在，则过滤掉
        return !existsInSelected;
    });
};

export default {
    name: "editPermissions",
    inject: ["reload"],
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        permissions: {
            type: Object,
            default: () => {},
        },
        lang: {
            type: String,
            default: "en",
        },
    },
    watch: {
        changeDevice(aa) {
            console.log(aa, "changeDevice");
        },
    },
    data() {
        return {
            user: 0,
            device: 0,
            search: "",
            ctrl: [], // 控制的分组，用于页面展示
            allGroup: [], // 所有
            treeData: [], // 分组列表数据
            enterpriseID: Number(this.$route.params.companyName),
            loading: false,
            changeDevice: [], // 选中状态有变化的设备
            allCheckedDevice: [], // 所有选中的设备
            saveBtnLoading: false,
            searchTree: [],
            searchTree2: [],
        };
    },
    components: {},
    computed: {
        ...mapState({
            groudInfo: (state) => state.enterprise.GROUP_LIST,
        }),
        // 控制分组状态发生变化的分组
        folderChanged() {
            let folder = [];
            this.treeData.forEach((it) => {
                let currFolderStatus = it.checked; // 当前分组的实时选中状态0/1/2（未选中/部分选中/全部选中）
                if (it.isChecked === false && it.indeterminate === true) {
                    currFolderStatus = 1;
                } else if (
                    it.isChecked === false &&
                    it.indeterminate === false
                ) {
                    currFolderStatus = 0;
                } else if (
                    it.isChecked === true &&
                    it.indeterminate === false
                ) {
                    currFolderStatus = 2;
                }

                // 当前分组状态和原始的分组状态不一致时push
                currFolderStatus !== it.checked &&
                    folder.push({ folderID: it.id, checked: currFolderStatus });
            });

            return folder;
        },
    },
    mounted() {
        this.getTreeData().then(() => {
            this.allGroup = this.treeData
                .filter((r) => r.devTotal > 0)
                .map((it) => {
                    const ctrlIt = this.ctrl.filter((t) => t.name === it.name);
                    return {
                        name: it.name,
                        devChecked:
                            ctrlIt.length > 0 ? ctrlIt[0].devChecked : 0,
                        devTotal: it.devTotal,
                    };
                });
            console.log(this.allGroup, "allGroup");
        });
        this.user = this.permissions.userPermissions;
        this.device = this.permissions.devicePermissions;
        this.ctrl = this.permissions.ctrlFolder.map((it) => {
            return {
                devChecked: it.devChecked,
                devTotal: it.devTotal,
                name: it.name,
            };
        });

        console.log(this.groudInfo, "name是否一样");
    },
    methods: {
        ...mapMutations({
            updataIsRoleType: "enterprise/UPDATE_ROLE_TYPE",
        }),
        // 获取初始树父级数据
        getTreeData() {
            this.loading = true;
            const params = {
                enterpriseID: this.enterpriseID,
                rolesID: this.permissions.id,
            };
            return getRoleGroupList(params)
                .then((res) => {
                    console.log(res, "获取初始树父级数据");
                    if (res.code === 200) {
                        this.treeData = formatparentData(res.data);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 异步加载子任务列表子节点
        loadChildrenMethod({ row }) {
            console.log(row, "节点");
            const params = {
                enterpriseID: this.enterpriseID,
                rolesID: this.permissions.id,
                folderID: row.id,
                offset: 0,
                rows: 9999,
            };
            // 异步加载子节点
            return getRoleGoupDevList(params).then((res) => {
                if (res.code === 200) {
                    const children = formatChildrenData(res.data, row);

                    // 处理子数据未加载父级全选操作
                    const selectData = children.filter((it) => {
                        console.log(it, !it.checked !== !it.isChecked);
                        return !it.checked !== !it.isChecked;
                    });

                    console.log(selectData, "bbbb");
                    this.changeDevice = dealChange(
                        this.changeDevice,
                        selectData
                    ).concat(selectData);
                    // 树形结构子数据已经加载
                    console.log(this.changeDevice, " this.changeDevice");
                    return children;
                }
            });
        },
        toggleMethod({ expanded, row, column, columnIndex }) {
            console.log(expanded, row, column, columnIndex, "展开了啦啦啦啦");
            return true;
        },
        selectChange({ $event, row, ...ab }) {
            $event.stopPropagation();

            if (!row.parentID) {
                // 勾选父级（分组）操作
                console.log(row, row.children, "色了幅度萨芬");
                if (row.children.length > 0) {
                    // 处理子数据已经加载之后，父级勾选操作

                    this.changeDevice = dealChange(
                        this.changeDevice,
                        row.children
                    ).concat(
                        row.children.filter((it) => {
                            console.log(it, !it.checked !== !it.isChecked);
                            return !it.checked !== !it.isChecked;
                        })
                    );
                    console.log(this.changeDevice, "哦买噶");
                    // 树形结构子数据已经加载
                    this.setCtrlDev();
                } else {
                    this.$refs.xTree.reloadTreeExpand(row);

                    // 树形结构子数据未加载，勾选父级复选框
                    this.setCtrlDev(row);
                }
            } else {
                // 勾选子级（设备）操作
                const selectData = [
                    {
                        // TODO
                        // deviceID: row.deviceID,
                        // isChecked: row.isChecked,
                        ...row,
                    },
                ];
                this.changeDevice = dealChange(this.changeDevice, selectData);
                if (!row.isChecked !== !row.checked) {
                    this.changeDevice = this.changeDevice.concat(selectData);
                }

                console.log(this.changeDevice, "000000");
                // 树形结构子数据已经加载
                this.setCtrlDev();
            }
            console.log(ab, "ab", ab.reds);
        },
        // 是否允许勾选
        checkboxsMethod({ row }) {
            if (this.permissions.type === 1) {
                // 禁止超级管理员勾选
                return false;
            } else {
                // 分组下设备总数为0禁止勾选
                return true;
            }
            //   return true
        },
        handleClose() {
            this.$emit("update:visible", false);
        },
        searchChange() {
            if (!this.search.trim()) {
                return;
            }
            this.loading = true;
            const params = {
                enterpriseID: this.enterpriseID,
                keyWords: this.search.trim(),
                rolesID: this.permissions.id,
            };

            queryTeamEquipment(params)
                .then((res) => {
                    console.log(res, "搜索");
                    this.searchTree = formatSearchTree(res.data);
                    console.log(this.$refs.sTree, "搜索9");
                    setTimeout(() => {
                        this.$refs.sTree.setAllTreeExpand(true);
                    }, 500);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 搜索表格选着
        searchSelectChange({ row }) {
            console.log(row, "搜索row");
        },
        debouncedsearchChange: debounce(function () {
            this.searchChange();
        }, 500),

        /**
         * 计算可控设备，用于页面可控设备的展示
         * @param nv 树形结构未加载子数据时：当前选中的父级数据/如果已加载子数据不传nv
         */
        setCtrlDev(nv) {
            console.log(nv, "计算可控设备", this.ctrl);
            if (nv) {
                // 树形结构未加载子数据时勾选复选框

                if (nv.isChecked) {
                    this.ctrl.forEach((it) => {
                        if (it.name === nv.name) {
                            it.devChecked = it.devTotal;
                            console.log("isCheckedtrue", this.ctrl);
                        }
                    });

                    // 当选择不在可控设备分组时
                    if (!this.ctrl.some((ctrlIT) => ctrlIT.name === nv.name)) {
                        this.ctrl.push({
                            name: nv.name,
                            devChecked: nv.devTotal,
                            devTotal: nv.devTotal,
                        });
                    }
                } else {
                    // this.ctrl.forEach((it) => {
                    //     it.name === nv.name && (it.devChecked = 0);
                    // });
                    this.ctrl = this.ctrl.filter((it) => {
                        return it.name !== nv.name;
                    });
                }
            } else {
                // 树形结构已经加载子数据是勾选复选框
                this.ctrl = this.permissions.ctrlFolder.map((it) => {
                    return {
                        devChecked: it.devChecked,
                        devTotal: it.devTotal,
                        name: it.name,
                    };
                });

                console.log("++++++++++++++++++++++++++++++++", this.ctrl);
                // 计算搜索树时的可控设备
                if (this.changeDevice.length > 0) {
                    console.log("onoa ");
                    this.changeDevice.forEach((change) => {
                        // 遍历 ctrl 数组
                        this.ctrl.forEach((ctrlItem, i) => {
                            // 如果 changeDev 数组中的 parentName 与 ctrl 数组中的 name 匹配
                            if (change.parentName === ctrlItem.name) {
                                // 根据 changeDev 数组中的 isChecked 属性，更新 ctrlItem 对象的 devChecked 属性
                                if (change.isChecked) {
                                    ctrlItem.devChecked++;
                                } else {
                                    ctrlItem.devChecked--;
                                }
                            }
                        });

                        // 当选择不在可控设备分组时
                        if (
                            !this.ctrl.some(
                                (ctrlIT) => ctrlIT.name === change.parentName
                            )
                        ) {
                            console.log(this.ctrl, "哦妈妈");
                            this.ctrl.push({
                                name: change.parentName,
                                devChecked: 1,
                                devTotal: change.parentDevTotal,
                            });
                        }
                    });
                }
            }
        },
        async save() {
            const params = {
                enterpriseID: this.enterpriseID,
                rolesID: this.permissions.id,
                userPermissions: this.user,
                devicePermissions: this.device,
                data: this.changeDevice.map((r) => {
                    return {
                        deviceID: r.deviceID,
                        checked: r.isChecked ? 1 : 0,
                    };
                }),
                folderChanged: this.folderChanged,
            };

            this.saveBtnLoading = true;
            const res = await saveRoleSettings(params);
            this.saveBtnLoading = false;
            if (res.code === 200) {
                this.$emit("saveSucc");

                console.log(
                    this.user !== this.permissions.userPermissions ||
                        this.device !== this.permissions.devicePermissions,
                    "是否改变"
                );
                console.log(this.groudInfo, "name是否一样");
                // 是否更新路由
                if (
                    this.user !== this.permissions.userPermissions ||
                    this.device !== this.permissions.devicePermissions
                ) {
                    // 如果是修改了用户权限或者设备权限
                    if (
                        this.permissions.name === this.groudInfo[0].roleName ||
                        ([1, 2].includes(this.permissions.type) &&
                            this.permissions.type === this.groudInfo[0].role)
                    ) {
                        // 如果是修改的是当前用户的角色需要更新路由
                        this.updataIsRoleType(true);
                        this.$router.go(0);
                    }
                }
                // 是否更新路由 end
            } else {
                this.$message.error(
                    this.$t(`subscribeErr.${Math.abs(res.code)}`)
                );
            }
        },
        // 跳转到部署设备页面
        goDeploy() {
            this.$router.push({ name: "deviceDeploy" });
        },
    },
    created() {},
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
    margin-bottom: 0;
}

/deep/ .el-dialog__close {
    font-size: 20px;
    color: #000;
    font-weight: 700;
    position: absolute;
    top: 20px;
    right: 10px;
}

/deep/ .el-drawer__body {
    padding: 0 35px;
}

.permis-edit {
    h2 {
        font-size: 20px;
    }
}

/deep/ .el-form--label-top .el-form-item__label {
    font-size: 16px;
    color: #000;
    font-weight: 700;
}

.el-radio-group {
    display: flex;
    justify-content: space-between;
}

.group-tree {
    margin-top: 20px;
    border: 1px solid #ccc;
    height: calc(100vh - 550px);
    min-height: 300px;
    border-radius: 4px;
    overflow-x: hidden;
    margin-bottom: 70px;
}

/deep/ .col--checkbox {
    .vxe-cell {
        padding: 0 0 0 10px !important;
        text-align: left;
    }
}

/deep/ [rowid*="rroot"] td:nth-child(2) .vxe-cell {
    padding-left: 27px;
}

/deep/ .group-tree thead {
    display: none !important;
}

/deep/ .group-tree .vxe-table--render-default .vxe-cell {
    padding-left: 10px;
    padding-right: 10px;
}

/deep/ .group-tree .col--last {
    text-align: right;
    color: #808080;
}

.drawer-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px 35px;
    border-top: 1px solid #eee;
    background: #fff;
    z-index: 100;
    text-align: right;

    .el-button {
        width: 120px;
    }
}

/deep/ .el-tag {
    border-color: #eaf2fe;
}

/deep/ .el-radio__label {
    line-height: 16px;
}

/deep/ .el-loading-spinner {
    margin-top: -55px;
    left: 0;
    font-size: 16px;
}

/deep/ .vxe-cell--checkbox .vxe-checkbox--icon {
    position: relative;
    z-index: 10;
}

/deep/ .table-empty i {
    height: 112px;
}

/deep/ .group-tree .vxe-checkbox--label {
    padding: 0;
}

/deep/ .vxe-cell--checkbox:hover .other-tips-cnt {
    display: block;
}

/deep/ .el-radio__inner {
    width: 16px;
    height: 16px;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
    background: #fff;
    border: 3px solid #3078f8;
}

/deep/ .el-radio__input.is-checked .el-radio__inner::after {
    width: 8px;
    height: 8px;
    background: #3078f8;
}

.tips-x {
    white-space: normal;
    color: #6b6d73;

    .tips-cnt {
        &.lf {
            left: -200px;
        }

        &.btm {
            bottom: auto;
            top: 5px;
        }

        &.cet {
            left: -185px;
        }

        &-rt {
            left: auto;
            right: -228px;
        }
    }
}

.other-tips-cnt {
    position: absolute;
    width: 370px;
    color: #6b6d73;
    z-index: 20;
    display: none;
    background: #fff;

    .tips-cnt-txt {
        margin: 0;
    }
}

.tips {
    &-cnt-txt {
        background: #212d43;
        color: #fff;
        font-size: 14px;
        line-height: 1.357;
    }

    .tips-cnt {
        width: 270px;
    }
}

.av-pt,
.av-it,
.av-es,
.av-fr,
.av-de {
    .tips-cnt {
        width: 400px;

        &.lf {
            left: -350px;
        }
    }
}

.icon-dev {
    display: inline-block;
    vertical-align: middle;
    width: 24px;
    height: 24px;
    margin-right: 7px;
    background: url("@/assets/icon/icon_dev.png") no-repeat center center;
}

/deep/ .vxe-table--render-default .vxe-table--empty-content {
    width: 100%;
    padding: 0 40px;
}

.av-de,
.av-es,
.av-it,
.av-fr,
.av-pt {
    .empty-device {
        margin-top: 0 !important;
    }
}
</style>
